$(function() {
  const free_shipping_threshold_eu = 50;
  const shipping_cost_eu = 595; // €5.95

  const free_shipping_threshold_au = 100;
  const free_shipping_threshold_ca = 100;
  const shipping_cost_au = 9.00;
  const shipping_cost_ca = 8.00;

  const free_shipping_threshold_pl = 215; // Poland
  const shipping_cost_pl = 13.00;        // Poland

  /**
   * Intercept cart-related fetch requests so the drawer refreshes after:
   * - add to cart
   * - remove from cart
   * - quantity change
   * - cart refresh
   */
  function catchRequest() {
    var originalFetch = window.fetch;

    window.fetch = function() {
      const request = originalFetch.apply(window, arguments);

      const url = arguments[0];
      const urlString = typeof url === 'string' ? url : url && url.url;

      if (
        urlString &&
        (
          urlString.includes('/cart.js') ||
          urlString.includes('/cart/add') ||
          urlString.includes('/cart/change') ||
          urlString.includes('/cart/update')
        )
      ) {
        request.then(function() {
          setTimeout(refreshCart, 250);
          setTimeout(refreshCart, 700);
        });
      }

      return request;
    };
  }

  /**
   * Count qualifying items (pads) for the B2G1 banner.
   */
  function countPads(items) {
    const arr = (window.CW_B2G1_IDS || []).map(Number).filter(n => !Number.isNaN(n));
    const ids = new Set(arr);
    const excludedWords = /(keyboard|keycap|aviator cable)/i;

    const totalItems = (items || []).reduce((n, i) => {
      const title = (i.title || '').toLowerCase();
      if (excludedWords.test(title)) return n;
      return n + Number(i.quantity || 0);
    }, 0);

    if (ids.size === 0) return totalItems;

    const whitelistedCount = (items || []).reduce((n, i) => {
      const title = (i.title || '').toLowerCase();
      if (excludedWords.test(title)) return n;
      const qualifies = ids.has(Number(i.product_id));
      return n + (qualifies ? Number(i.quantity || 0) : 0);
    }, 0);

    return whitelistedCount > 0 ? whitelistedCount : totalItems;
  }

  /**
   * Reset drawer shipping/progress UI before every render.
   * Important: do not clear the progress message span here.
   */
  function resetShippingUi() {
    $('.shipping-progress').hide().removeClass('is-success');
    $('.free-shipping-badge').hide();

    $('.shipping-progress .progress-bar').show();
    $('.shipping-progress .progress-bar-value').css('width', '0%');

    $('.cw-cart-drawer-subtotals .discount-row').hide();
  }

  /** Render everything */
  function renderElements(cart_value, cart) {
    resetShippingUi();

    if (!cart || !cart.items || cart.items.length === 0 || cart.item_count === 0) {
      return;
    }

    if (['european-union', 'germany', 'france', 'spain', 'italy'].includes(cw_market_handle)) {
      if (cart_value < free_shipping_threshold_eu) {
        const shipping_cost_eu_display = shipping_cost_eu / 100;
        const cart_value_with_shipping = cart_value + shipping_cost_eu_display;

        const money_left = Math.max(free_shipping_threshold_eu - cart_value_with_shipping, 0);
        const percent_left = Math.min((cart_value_with_shipping * 100) / free_shipping_threshold_eu, 100);

        $('.shipping-progress').show();
        $('.shipping-progress .progress-bar').show();
        $('.shipping-progress .progress-bar-value').css('width', percent_left + '%');
        $('.shipping-progress span').html(CW_formatMoney(money_left * 100));

        $('.cw-cart-drawer-subtotals .discount-row.shipping-number').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number .value').text(CW_formatMoney(shipping_cost_eu));
      } else {
        $('.free-shipping-badge').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();
      }

      $('.cw-cart-drawer-subtotals .discount-row.taxes-n-duties').show();

    } else if (['australia'].includes(cw_market_handle)) {
      if (cart_value < free_shipping_threshold_au) {
        const money_left = free_shipping_threshold_au - cart_value;
        const percent_left = (cart_value * 100) / free_shipping_threshold_au;

        $('.shipping-progress').show();
        $('.shipping-progress .progress-bar').show();
        $('.shipping-progress .progress-bar-value').css('width', percent_left + '%');
        $('.shipping-progress span').html(CW_formatMoney(money_left * 100));

        $('.cw-cart-drawer-subtotals .discount-row.shipping-number').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number .value').text(CW_formatMoney(shipping_cost_au * 100));
      } else {
        $('.free-shipping-badge').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();
      }

      $('.cw-cart-drawer-subtotals .discount-row.taxes-n-duties').show();

    } else if (['canada'].includes(cw_market_handle)) {
      if (cart_value < free_shipping_threshold_ca) {
        const money_left = free_shipping_threshold_ca - cart_value;
        const percent_left = (cart_value * 100) / free_shipping_threshold_ca;

        $('.shipping-progress').show();
        $('.shipping-progress .progress-bar').show();
        $('.shipping-progress .progress-bar-value').css('width', percent_left + '%');
        $('.shipping-progress span').html(CW_formatMoney(money_left * 100));

        $('.cw-cart-drawer-subtotals .discount-row.shipping-number').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number .value').text(CW_formatMoney(shipping_cost_ca * 100));
      } else {
        $('.free-shipping-badge').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();
      }

    } else if (['poland'].includes(cw_market_handle)) {
      if (cart_value < free_shipping_threshold_pl) {
        const money_left = free_shipping_threshold_pl - cart_value;
        const percent_left = (cart_value * 100) / free_shipping_threshold_pl;

        $('.shipping-progress').show();
        $('.shipping-progress .progress-bar').show();
        $('.shipping-progress .progress-bar-value').css('width', percent_left + '%');
        $('.shipping-progress span').html(CW_formatMoney(money_left * 100));

        $('.cw-cart-drawer-subtotals .discount-row.shipping-number').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number .value').text(CW_formatMoney(shipping_cost_pl * 100));
      } else {
        $('.free-shipping-badge').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();
      }

      $('.cw-cart-drawer-subtotals .discount-row.taxes-n-duties').show();

    } else if (['gb', 'united-states-2'].includes(cw_market_handle)) {
      const pads = countPads((cart && cart.items) || []);
      const $barWrap  = $('.shipping-progress');
      const $progress = $('.shipping-progress .progress-bar');
      const $fill     = $('.shipping-progress .progress-bar-value');

      $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();

      if (cw_market_handle === 'united-states-2') {
        $('.cw-cart-drawer-subtotals .discount-row.taxes-n-duties').show();
      }

      $('.free-shipping-badge').hide();

      const $host = $('.shipping-progress > div:first');
      if (!$host.find('#uk-offer-text').length) {
        $host.html('<span id="uk-offer-text"></span>');
      }

      const $text = $('#uk-offer-text');

      if (pads <= 0) {
        $text.text('🔥 Add 2 Pads To Unlock A FREE Mousepad!');
        $barWrap.show();
        $progress.show();
        $fill.css('width', '0%');
        $barWrap.removeClass('is-success');
      } else if (pads === 1) {
        $text.text('🔥 Almost There — Add 1 More Pad To Unlock Your FREE Mousepad!');
        $barWrap.show();
        $progress.show();
        $fill.css('width', '33%');
        $barWrap.removeClass('is-success');
      } else if (pads === 2) {
        $text.text('🎉 Add Any 3rd Pad — It’s FREE On Us!');
        $barWrap.show();
        $progress.show();
        $fill.css('width', '66%');
        $barWrap.removeClass('is-success');
      } else {
        $text.text('🔥 You Scored a FREE Mousepad!');
        $barWrap.show();
        $progress.hide();
        $barWrap.addClass('is-success');
      }

      $text.addClass('pulse');
      setTimeout(() => $text.removeClass('pulse'), 1500);

    } else {
      $('.cw-cart-drawer-subtotals .discount-row.shipping-calculated').show();
    }
  }

  function getCartValue(cart) {
    return parseFloat((cart.items_subtotal_price / 100.0).toFixed(2));
  }

  function refreshCart() {
    fetch('/cart.js', {
      cache: 'no-store'
    })
      .then(r => r.json())
      .then(cart => {
        renderElements(getCartValue(cart), cart);
      });
  }

  catchRequest();

  refreshCart();

  document.addEventListener('cart:updated', refreshCart);
  document.addEventListener('ajaxCart:updated', refreshCart);
  document.addEventListener('drawer:open', refreshCart);
  document.addEventListener('cart:open', refreshCart);

  document.addEventListener('click', function(e) {
    if (
      e.target.closest('.ajaxcart__qty') ||
      e.target.closest('[data-update-quantity]') ||
      e.target.closest('[data-remove]') ||
      e.target.closest('.ajaxcart__qty-adjust') ||
      e.target.closest('.js-drawer-open-cart') ||
      e.target.closest('[data-cart-trigger]') ||
      e.target.closest('.cart-link') ||
      e.target.closest('[href="/cart"]') ||
      e.target.closest('[name="add"]') ||
      e.target.closest('button[type="submit"]')
    ) {
      setTimeout(refreshCart, 250);
      setTimeout(refreshCart, 700);
      setTimeout(refreshCart, 1200);
    }
  });

  document.addEventListener('change', function(e) {
    if (e.target.closest('.ajaxcart__qty')) {
      setTimeout(refreshCart, 250);
      setTimeout(refreshCart, 700);
    }
  });
});